// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-types-post-js": () => import("./../src/templates/types/post.js" /* webpackChunkName: "component---src-templates-types-post-js" */),
  "component---src-templates-types-page-js": () => import("./../src/templates/types/page.js" /* webpackChunkName: "component---src-templates-types-page-js" */),
  "component---src-templates-index-js": () => import("./../src/templates/index.js" /* webpackChunkName: "component---src-templates-index-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

